/**
 * Mega Menu Performance Cache
 * Caches rendered mega menu HTML in localStorage for faster subsequent loads
 * Works with existing desktop-mega.liquid structure and JavaScript
 */

(function() {
  'use strict';
  
  const CACHE_KEY = 'mega_menu_html_cache';
  const CACHE_VERSION = '1.0';
  const CACHE_EXPIRY = 48 * 60 * 60 * 1000; // 48 hours
  
  // Wait for DOM to be ready
  function init() {
    const desktopMega = document.querySelector('#desktop-mega');
    if (!desktopMega) return;

    // Check if we should use cache
    function shouldUseCache() {
      // Don't cache in admin/design mode
      if (document.body.classList.contains('shopify-design-mode')) return false;
      
      // Check if cache exists and is valid
      try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (!cached) return false;
        
        const data = JSON.parse(cached);
        const now = Date.now();
        
        // Validate version and expiry
        if (data.version !== CACHE_VERSION || (now - data.timestamp) > CACHE_EXPIRY) {
          localStorage.removeItem(CACHE_KEY);
          return false;
        }
        
        return true;
      } catch (e) {
        localStorage.removeItem(CACHE_KEY);
        return false;
      }
    }

    // Get cached content
    function getCachedContent() {
      try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (!cached) return null;
        const data = JSON.parse(cached);
        return data.html;
      } catch (e) {
        return null;
      }
    }

    // Save to cache
    function cacheContent(html) {
      try {
        const data = {
          html: html,
          version: CACHE_VERSION,
          timestamp: Date.now()
        };
        localStorage.setItem(CACHE_KEY, JSON.stringify(data));
      } catch (e) {
        // Storage quota exceeded or disabled - silently fail
      }
    }

    // Check if menu content is already loaded
    const currentContent = desktopMega.innerHTML.trim();
    const hasContent = currentContent.length > 0;
    
    // If cache is available and menu is empty, use cache
    if (!hasContent && shouldUseCache()) {
      const cached = getCachedContent();
      if (cached) {
        desktopMega.innerHTML = cached;
        // Trigger any initialization that might be needed
        const event = new CustomEvent('megaMenuCached');
        document.dispatchEvent(event);
        return;
      }
    }

    // Cache current content if it exists and hasn't been cached yet
    if (hasContent && !desktopMega.dataset.cached) {
      // Small delay to ensure all content is fully rendered
      setTimeout(function() {
        const content = desktopMega.innerHTML.trim();
        if (content) {
          cacheContent(content);
          desktopMega.dataset.cached = 'true';
        }
      }, 100);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already ready, run immediately
    init();
  }
})();

